import { render } from "./detail-staff-salary.vue?vue&type=template&id=a6982634&scoped=true&ts=true"
import script from "./detail-staff-salary.vue?vue&type=script&lang=ts"
export * from "./detail-staff-salary.vue?vue&type=script&lang=ts"

import "./detail-staff-salary.vue?vue&type=style&index=0&id=a6982634&scoped=true&lang=stylus"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6982634"]])

export default __exports__